<template>
	<div style="padding: 10px 10px 10px 0;">
		<!-- 新增/修改弹框 -->
		<el-dialog :title="`选择派单工人`" :visible.sync="show" width="30%" @close="close">
			<el-select v-model="userId" placeholder="请选择">
				<el-option v-for="item in users" :key="item.value" :label="item.name" :value="item.id"></el-option>
			</el-select>
			<span slot="footer" class="dialog-footer">
				<el-button @click="show=false">取 消</el-button>
				<el-button type="primary" @click="pd">确 定</el-button>
			</span>
		</el-dialog>
		<!-- 详情 -->
		<el-dialog title="详情" :visible.sync="showDet" width="30%">
			<el-row :gutter="20">
				<el-col :span="8">
					<b>区域编号 : </b>
					<span>{{row.number}}</span>
				</el-col>
				<el-col :span="8">
					<b>区域名称 : </b>
					<span>{{row.name}}</span>
				</el-col>
				<el-col :span="8">
					<b>异常类型 : </b>
					<span>{{row.exceptionReason}}</span>
				</el-col>
				<el-col :span="8">
					<b>异常时间 : </b>
					<span>{{row.exceptionTime?row.exceptionTime.split("T")[0]:""}}</span>
				</el-col>
				<el-col :span="8">
					<b>处理人 : </b>
					<span>{{row.dealName}}</span>
				</el-col>
				<el-col :span="8">
					<b>处理时间 : </b>
					<span>{{row.dealTime?row.dealTime.split("T")[0]:""}}</span>
				</el-col>
				<el-col :span="24">
					<b>处理说明 : </b>
					<span>{{row.dealExplain}}</span>
				</el-col>
				<el-col :span="12" v-for="item in row.dealPicList">
					<img :src="`http://192.168.0.212:8008/area/preview/${item.name}`" width="100%" style="box-shadow: 0 0 3px #b0b0b0;">
				</el-col>
			</el-row>
			<span slot="footer" class="dialog-footer">
				<el-button @click="showDet=false">取 消</el-button>
			</span>
		</el-dialog>
		<el-tabs v-model="selectForm.flag" @tab-click="handleClick">
			<el-tab-pane label="已处理" name="1">
			</el-tab-pane>
			<el-tab-pane label="未处理" name="0">
			</el-tab-pane>
		</el-tabs>
		<!-- 搜索条件 -->
		<el-form :inline="true" :model="selectForm" ref="selectForm">
			<el-form-item label="区域编号" prop="number">
				<el-input v-model="selectForm.number" placeholder="区域编号"></el-input>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="getAll">查询</el-button>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="$refs.selectForm.resetFields();getAll();">重置</el-button>
			</el-form-item>
		</el-form>
		<!-- 表格 -->
		<el-table :data="data" style="width: 100%" border>
			<el-table-column prop="number" label="区域编号" align="center"></el-table-column>
			<el-table-column prop="name" label="区域名称" align="center"></el-table-column>
			<el-table-column prop="exceptionReason" label="异常类型" align="center"></el-table-column>
			<el-table-column prop="exceptionTime" label="异常时间" align="center">
				<template slot-scope="{row}">{{row.exceptionTime?row.exceptionTime.split("T")[0]:""}}</template>
			</el-table-column>
			<el-table-column v-if="selectForm.flag==1" prop="dealExplain" label="处理说明" align="center"></el-table-column>
			<el-table-column v-if="selectForm.flag==1" prop="dealName" label="处理人" align="center"></el-table-column>
			<el-table-column v-if="selectForm.flag==1" prop="dealTime" label="处理时间" align="center">
				<template slot-scope="{row}">{{row.dealTime?row.dealTime.split("T")[0]:""}}</template>
			</el-table-column>
			<el-table-column label="操作" align="center">
				<template slot-scope="{row}">
					<el-button v-if="selectForm.flag==1" type="text" @click="lookRow(row)">查看详情</el-button>
					<el-button v-if="selectForm.flag==0" type="text" @click="paidan(row)">派单</el-button>
				</template>
			</el-table-column>
		</el-table>
		<!-- 分页 -->
		<el-pagination @size-change="sizeChange" @current-change="currentChange" :page-sizes="[10, 20, 30, 40]"
			:page-size="selectForm.rows" layout="total, sizes, prev, pager, next, jumper" :total="totalNum"
			style="margin-top: 10px;">
		</el-pagination>
	</div>
</template>

<script>
	import publicExport from '../../assets/js/publicExport.js';
	export default {
		data() {
			return {
				userId:"",//工人id
				users: [], //派单工人
				data: [], //表格数据
				selectForm: { //查询条件
					page: 1, //当前页
					rows: 10, //页大小
					number: "", //编号
					flag: "1" //已处理 1  未处理 0
				},
				row: {},
				totalNum: 0, //数据总数
				show: false, //控制弹窗
				showDet: false,
				title: "新增",
			}
		},
		methods: {
			pd(){
				this.show = false;
				let id = this.row.id;
				let userId = this.userId;
				let userName = ""
				this.users.forEach(item=>{
					if(item.id==userId) {
						userName = item.name
					}
				})
				this.$http.post("/api/area/updatePaiDan",{
					id,userId,userName
				}).then(res=>{
					if(res.data.code==0) {
						this.$message.success("派单成功")
					}
				})
			},
			paidan(row) {
				this.show = true;
				this.row = row
			},
			lookRow(row) {
				this.showDet = true;
				this.row = row
			},
			handleClick() {
				this.getAll()
			},
			dc() {
				// publicExport("/api/export/uploadSecurityArea", this.selectForm, "区域异常")
			},
			close() { //弹框关闭
				this.$refs.form.resetFields()
				this.form = JSON.parse(JSON.stringify(this.oldForm));
			},
			getAll() { //获取表格数据
				this.$http.post(`/api/area/selectExceptionByPage`, this.selectForm).then(res => {
					this.data = res.data.data.items;
					this.totalNum = res.data.data.totalNum;
				})
			},
			sizeChange(size) { //页大小被修改
				this.selectForm.rows = size;
				this.getAll();
			},
			currentChange(page) { //当前页被修改  
				this.selectForm.page = page;
				this.getAll();
			},
			getUsers() { //获取派单工人
				this.$http.get("/api/area/selectAllPaiDan").then(res => {
					this.users = res.data.data
				})
			}
		},
		created() {
			this.getAll();
			this.getUsers();
		}
	}
</script>

<style scoped="scoped">
	.el-col {
		margin: 5px 0;
	}
</style>
